@if (stack$ | async; as stack) {
  @for (m of stack; track m.id; let i = $index) {
    <div
      (click)="onBackdropClick(m)"
      [class.core-modal-overlay--closing]="m.isClosing"
      [style.z-index]="9999 + i"
      aria-hidden="true"
      class="core-modal-overlay"
    ></div>

    <div
      [attr.aria-label]="m.options.ariaLabel"
      [class.core-modal-viewport--closing]="m.isClosing"
      [style.z-index]="9999 + i + 1"
      aria-modal="true"
      class="core-modal-viewport"
      role="dialog"
    >
      <div
        (click)="$event.stopPropagation()"
        [ngClass]="sizeClass(m.options.size)"
        class="core-modal-panel"
      >
        @if (m.options.showCloseButton) {
          <button (click)="onCloseClick(m)" aria-label="Cerrar"
                  class="btn btn-neutral-text core-modal-close" type="button">
            <img alt="Close" class="filter-neutral-900 h-5" src="/assets/icons/feather/x.svg">
          </button>
        }

        <core-modal-outlet
          [component]="m.component"
          [inputs]="m.inputs || {}"
          [outputs]="m.outputs || {}"
        />
      </div>
    </div>
  }
}
